module.exports = __webpack_public_path__ + "img/23.8af949e2.jpg";